// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationBanner_container__e4120","closeItIcon":"NotificationBanner_closeItIcon__cyAqk","message":"NotificationBanner_message__1nKlr"};